export function formatToCsvSyntax(data: string[][]): string {
  return data
    .map((row) =>
      row
        .map((item) => {
          let wrapped = item;

          // If item contains a comma, newline, or double-quote,
          // escape these characters and wrap item in double quotes.
          if (item.indexOf(',') !== -1 || item.indexOf('\n') !== -1 || item.indexOf('"') !== -1) {
            wrapped = `"${item.replace(/"/g, '""')}"`;
          }

          return wrapped;
        })
        .join(',')
    )
    .join('\n');
}
